import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import dreamOne from "../../images/dream.png";
import "../../../src/product.css";

const DreamOne = () => {
  return (
    <>
      <Header />

      <main className="product-page container text-center">
        {/* Product Hero */}

        <h2 id="title">DREAM ONE</h2>

        <section className="product-hero">

          <div className="product-image-wrapper">
            <img
              src={dreamOne}
              alt="MJ Motor Dream One"
              className="product-image"
            />
          </div>

          <div className="product-info">

            <p>
              The Dream One is a compact urban electric vehicle introduced in Addis Ababa, Ethiopia. Designed specifically for
              city commuting and short-range daily urban travel, it offers a
              practical and eco-friendly alternative for everyday mobility.
            </p>

          </div>
        </section>

        {/* Specifications */}

        <section className="product-specifications">

          <div className="section-heading">
            <span>KEY FEATURES</span>
            <h2>Specifications</h2>
          </div>

          <div className="spec-grid">

            <div className="spec-card">
              <span>Power Type</span>
              <strong>100% Electric</strong>
            </div>

            <div className="spec-card">
              <span>Vehicle Type</span>
              <strong>Compact Urban EV</strong>
            </div>

            <div className="spec-card">
              <span>Charging</span>
              <strong>220V Household Charging</strong>
            </div>

            <div className="spec-card">
              <span>Usage</span>
              <strong>City Commuting</strong>
            </div>

            <div className="spec-card">
              <span>Travel</span>
              <strong>Short-Range Urban Travel</strong>
            </div>

          </div>
        </section>

      </main>

      <Footer />
    </>
  );
};

export default DreamOne;